import { colorsPalettes } from "@similarweb/styles";
import styled from "styled-components";

import { RadioButton } from "@similarweb/ui-components";
import { Flex, Stack } from "@similarweb/ui-components/foundations";

import { Textarea } from "app/pages/sales-intelligence/common-components/Textarea/Textarea";

const SCORING_WIZARD_HORIZONTAL_PADDING = "16px";
// Filter panel chips/sections ship with 16px inner padding; bleed cancels the duplicate inset in the wizard.
const SCORING_FILTERS_PANEL_INNER_PADDING = "16px";

export const StyledScoringFiltersPanelBleed = styled.div`
    margin: 0 calc(-1 * ${SCORING_FILTERS_PANEL_INNER_PADDING});
    min-width: 0;
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
`;

export const SCORING_RULE_MODAL_STYLES = {
    content: {
        width: "1024px",
        maxWidth: "calc(100vw - 32px)",
        height: "calc(100vh - 64px)",
        maxHeight: "720px",
        padding: 0,
        display: "flex" as const,
        flexDirection: "column" as const,
    },
};

export const StyledScoringWizardHeader = styled(Flex)`
    padding: 20px ${SCORING_WIZARD_HORIZONTAL_PADDING} 16px;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid ${colorsPalettes.midnight["50"]};
`;

export const StyledScoringWizardStepperRow = styled(Flex)`
    padding: 16px ${SCORING_WIZARD_HORIZONTAL_PADDING};
    align-items: center;
    justify-content: center;
    gap: 12px;
    border-bottom: 1px solid ${colorsPalettes.midnight["50"]};
`;

export const StyledScoringWizardBody = styled(Stack)`
    flex: 1;
    min-height: 0;
    width: 100%;
    padding: 20px ${SCORING_WIZARD_HORIZONTAL_PADDING};
    background: ${colorsPalettes.carbon["0"]};
`;

export const StyledScoringWizardFooter = styled(Flex)`
    padding: 16px ${SCORING_WIZARD_HORIZONTAL_PADDING};
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid ${colorsPalettes.midnight["50"]};
    background: ${colorsPalettes.carbon["0"]};
`;

export const StyledScoringWizardDivider = styled.div`
    flex-shrink: 0;
    margin: 0 calc(-1 * ${SCORING_WIZARD_HORIZONTAL_PADDING});
    border-bottom: 1px solid ${colorsPalettes.midnight["50"]};
`;

export const StyledFullWidthTextarea = styled(Textarea)`
    max-width: none;
    width: 100%;

    textarea {
        width: 100%;
        max-width: 100%;
        min-width: 0;
    }
`;

export const StyledTeamScopeOption = styled(Flex)<{ $isSelected: boolean }>`
    padding: 12px 16px;
    border-radius: 8px;
    border: 1px solid ${({ $isSelected }) => ($isSelected ? colorsPalettes.blue["400"] : colorsPalettes.carbon["100"])};
    background: ${({ $isSelected }) => ($isSelected ? colorsPalettes.blue["100"] : colorsPalettes.carbon["0"])};
    cursor: pointer;
    align-items: flex-start;
    transition:
        border-color 0.15s ease,
        background 0.15s ease;

    &:hover {
        border-color: ${({ $isSelected }) => ($isSelected ? colorsPalettes.blue["400"] : colorsPalettes.blue["200"])};
    }
`;

export const StyledTeamScopeRadioButton = styled(RadioButton)`
    padding: 0;
    align-items: flex-start;
`;

export const StyledTeamStepScroll = styled.div`
    flex: 1;
    min-height: 0;
    overflow-y: auto;
`;

export const StyledTeamSelectionGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
`;

export const StyledTeamSelectionCard = styled(Flex)<{ $isSelected: boolean }>`
    padding: 16px 20px;
    border-radius: 8px;
    border: 2px solid ${({ $isSelected }) => ($isSelected ? colorsPalettes.blue["400"] : colorsPalettes.carbon["100"])};
    background: ${({ $isSelected }) => ($isSelected ? colorsPalettes.blue["100"] : colorsPalettes.carbon["0"])};
    cursor: pointer;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    transition:
        border-color 0.15s ease,
        background 0.15s ease;

    &:hover {
        border-color: ${({ $isSelected }) => ($isSelected ? colorsPalettes.blue["400"] : colorsPalettes.blue["200"])};
    }
`;
